import React, { useState, useRef, useEffect } from 'react';
import * as S from './style';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const NavigationMenu = ({
    items = [],
    logo = null,
    logoText = '',
    variant = 'horizontal',
    onItemClick,
    activeItem = '',
    className = '',
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const navRef = useRef(null);

    // 외부 클릭 시 메뉴 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setIsOpen(false);
                setActiveSubmenu(null);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleItemClick = (item) => {
        if (item.submenu) {
            setActiveSubmenu(activeSubmenu === item.id ? null : item.id);
        } else {
            if (onItemClick) {
                onItemClick(item);
            }
            setIsOpen(false);
            setActiveSubmenu(null);
        }
    };

    const handleSubmenuItemClick = (parentItem, subItem) => {
        if (onItemClick) {
            onItemClick(subItem, parentItem);
        }
        setIsOpen(false);
        setActiveSubmenu(null);
    };

    const renderMenuItem = (item) => {
        const isActive = activeItem === item.id;
        const hasSubmenu = item.submenu && item.submenu.length > 0;
        const isSubmenuOpen = activeSubmenu === item.id;

        return (
            <S.NavItem key={item.id} isActive={isActive} hasSubmenu={hasSubmenu}>
                <S.NavLink
                    onClick={() => handleItemClick(item)}
                    isActive={isActive}
                    hasSubmenu={hasSubmenu}
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleItemClick(item);
                        }
                    }}
                >
                    {item.icon && <S.ItemIcon>{item.icon}</S.ItemIcon>}
                    <S.ItemText>{item.label}</S.ItemText>
                    {hasSubmenu && (
                        <S.SubmenuIcon isOpen={isSubmenuOpen}>
                            {isSubmenuOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </S.SubmenuIcon>
                    )}
                </S.NavLink>

                {hasSubmenu && isSubmenuOpen && (
                    <S.Submenu>
                        {item.submenu.map((subItem) => (
                            <S.SubmenuItem key={subItem.id}>
                                <S.SubmenuLink
                                    onClick={() => handleSubmenuItemClick(item, subItem)}
                                    isActive={activeItem === subItem.id}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleSubmenuItemClick(item, subItem);
                                        }
                                    }}
                                >
                                    {subItem.icon && <S.SubmenuIcon>{subItem.icon}</S.SubmenuIcon>}
                                    <S.SubmenuText>{subItem.label}</S.SubmenuText>
                                </S.SubmenuLink>
                            </S.SubmenuItem>
                        ))}
                    </S.Submenu>
                )}
            </S.NavItem>
        );
    };
    const renderDesktopMenu = () => <S.DesktopMenu variant={variant}>{items.map(renderMenuItem)}</S.DesktopMenu>;

    return (
        <S.NavigationContainer ref={navRef} className={className} variant={variant}>
            {/* 로고 영역 */}
            <S.LogoSection>
                {logo && <S.LogoImage src={logo} alt={logoText} />}
                <S.LogoText>{logoText}</S.LogoText>
            </S.LogoSection>

            {/* 데스크톱 메뉴 */}
            {renderDesktopMenu()}
        </S.NavigationContainer>
    );
};

export default NavigationMenu;
